import sortBy from 'lodash/sortBy';
import { type OpenApiSchemaCategory } from '../../api/schema';
import { flattenNodes, type TreeRow } from '../../components/Tree';

type PickedCategoryModel = Pick<OpenApiSchemaCategory, 'id' | 'parent_id' | 'display_sequence'>;

export const sortCategories = <M extends PickedCategoryModel>(categories: M[]): TreeRow<M>[] => {
    const sortedItems = sortBy(categories, 'display_sequence');

    const { rows } = flattenNodes<M>(sortedItems, ({ id, parent_id }) => {
        return { id, parentId: parent_id };
    });

    return rows;
};
